import { all } from '@/http/api'
const state = {
  baseUrl: "https://www.wonsun.com.cn/wsfile/upload/",
  hideHeader: false,
  homeCarouselVisiblity: true, // 首页轮播图是否可见
  isShowHeaderAndFooter: true,
  dictItem: [],
  // 默认网站关键词
  metaInfo: {}
}

const mutations = {
  SET_ISSHOWHEADERANDFOOTER(state, isShowHeaderAndFooter) {
    state.isShowHeaderAndFooter = isShowHeaderAndFooter
  },
  SET_HIDEHEADER(state, hideHeader) {
    state.hideHeader = hideHeader
  },
  SET_HOMECAROUSELVISIBLITY(state, homeCarouselVisiblity) {
    state.homeCarouselVisiblity = homeCarouselVisiblity
  },
  CHANGE_SETTING: (state, { key, value }) => {
    // eslint-disable-next-line no-prototype-builtins
    if (state.hasOwnProperty(key)) {
      state[key] = value
    }
  }
}

const actions = {
  systemSetting({ dispatch }) {
    return new Promise((resolve, reject) => {
      // 全查数据字典
      all().then(res => {
        dispatch('changeSetting', { key: 'dictItem', value: res.data.zzjgList })
        resolve()
      }).catch(() => {
        reject(new Error('数据字典获取失败'))
      })
    })
  },
  changeSetting({ commit }, data) {
    // const { key, value } = data
    // localStorage.setItem(key, value)
    commit('CHANGE_SETTING', data)
  },
  setIsShowHeaderAndFooter({ commit }, isShowHeaderAndFooter) {
    commit('SET_ISSHOWHEADERANDFOOTER', isShowHeaderAndFooter)
  },
  setHideHeader({ commit }, hideHeader) {
    commit('SET_HIDEHEADER', hideHeader)
  },
  setHomeCarouselVisiblity({ commit }, homeCarouselVisiblity) {
    commit('SET_HOMECAROUSELVISIBLITY', homeCarouselVisiblity)
    commit('SET_HIDEHEADER', !homeCarouselVisiblity)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}